export default {
  newDesign: true,
  parameters: {
    landing_id: "ItLongFClS",
    segment: 9,
  },
  title:
    "Rispondi alle domande per ottenere un corso gratuito di creatività digitale per tuo figlio | Kodland",
  downtimeUrl: "https://www.kodland.org/it",
  startPage: {
    startBackground: "white",
    quizBackground: "#white",
    title:
      "Rispondi alle domande per ottenere un corso gratuito di creatività digitale per tuo figlio",
    subtitle:
      "Ti mostreremo come trasformare una passione per i dispositivi in un vantaggio:<br>💬 Scopri i talenti di tuo figlio in modo divertente<br>🌐 Tutto ciò che ti serve è un computer e una connessione a Internet<br>💙 Raccomandato da oltre 100.000 genitori",
    image: {
      url: "/welcome/it_longloc_fwd_spidey_pc.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/it_longloc_fwd_spidey_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Andiamo! 🔥 ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Grazie per aver scelto la nostra piattaforma educativa!",
    subtitle:
      "Sfortunatamente, tablet e smartphone non sono adatti per seguire le nostre classi. Speriamo ci sarà l'occasione di vederci in classe prossimamente!",
  },
  quizRotateBySteps: {
    1: {
      title: "Quanti anni ha tuo figlio?",
      type: "age",
      button: "",
    },
    2: {
      question:
        "Quanto tempo tuo figlio trascorre sui dispositivi (telefono, computer o tablet)?",
      answers: [
        "Meno di 1 ora al giorno",
        "Da 1 a 4 ore al giorno",
        "Più di 4 ore al giorno",
      ],
    },
    3: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/turkey_longquiz_softskills_4.webp",
      subtitle:
        "Cosa aspetta tuo figlio nelle lezioni?<br>✅ Proverà la creatività digitale: animazione, illustrazione, modellazione 3D, design<br>✅ Creerà i suoi primi progetti (collage, sito web, visualizzazione 3D di un intero mondo e la sua animazione per futuri cartoni animati e giochi, ecc.)<br>✅ Imparerà strumenti utili per creare opere d'arte digitali",
      button: "Eccellente!",
    },
    4: {
      question:
        "Tuo figlio ha accesso a un laptop o a un PC desktop per studiare?",
      answers: [
        "Sì, ha il proprio dispositivo 💻✅",
        "Sì, ma lo condivide con altri 🖥️👫",
        {
          answer: "No, non ha accesso regolare 🚫",
          stopAnswer: true,
        },
      ],
    },
    5: {
      question: "Come tuo figlio ricorda o impara meglio le cose nuove?",
      answers: [
        "Guardando (apprendente visivo) 👁️",
        "Facendo (apprendente pratico) 👐",
        "Ascoltando (apprendente uditivo) 🎧",
        "Attraverso la ripetizione e la pratica 🔄✏️",
      ],
    },
    6: {
      question:
        "Come si comporta tuo figlio quando lavora con altri in un gruppo?",
      answers: [
        "Gli piace collaborare e condividere idee 🤝💡",
        "Preferisce guidare e prendere il comando 🧑‍⚖️",
        "Lavora da solo, ma contribuisce se necessario 👤✔️",
        "Si sente timido o a disagio nei contesti di gruppo 😳",
      ],
    },
    7: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/quiz_br_2.webp",
      subtitle:
        "Offriamo sia format di apprendimento individuali che di gruppo, e teniamo conto dell'età dei bambini per adattare il processo a ciascun bambino nel miglior modo possibile.",
      button: "Andiamo!",
    },
    8: {
      question: "A scuola, cosa piace di più a tuo figlio?",
      answers: [
        "Esperimenti scientifici o sfide matematiche 🧪🔢",
        "Leggere e scrivere storie 📚✍️",
        "Arte, musica o attività creative 🎨🎶",
        "Educazione fisica o sport 🏃‍♀️🏋️‍♂️",
        "Altro 🙂",
      ],
    },
    9: {
      question: "Che tipo di attività o hobby attirano di più tuo figlio?",
      answers: [
        "Attività fisiche come sport o danza ⚽💃",
        "Hobby creativi come disegno, pittura o lavori manuali 🎨🖌️",
        "Hobby come puzzle, scacchi o programmazione ♟️💻",
        "Intrattenimento come videogiochi o video 🎮📺.",
        "Altro 🙂",
      ],
    },
    10: {
      title: "Congratulazioni!",
      typeInfo: "congrats",
      subtitle:
        "Su Kodland, gli studenti creano modelli 3D, fumetti, giochi e programmi. 30.000 bambini in tutto il mondo stanno imparando con noi!",
      button: "Siamo quasi alla fine 🎉",
    },
    11: {
      title:
        "Completa i tuoi dettagli di contatto per accedere al corso gratuito",
      type: "one-page-contacts",
      subtitle: "",
      button: "Quasi fatto 🔥",
    },
    12: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    13: {
      title: "Controlla questi dettagli per completare la registrazione ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ti ricordiamo che per la lezione avrai bisogno di un PC o laptop funzionante e che dovrai accompagnare tuo figlio per tutta la lezione. Ricorda che è individuale e personalizzato.",
      button: "Cos'altro?",
    },
    14: {
      title:
        "Controlla la tua email e WhatsApp prima della lezione di prova 📞",
      typeInfo: "whatsapp",
      subtitle:
        "24 ore prima della lezione ti invieremo un promemoria e 2 ore prima della lezione ti chiederemo di confermare la tua presenza. È molto importante rimanere in contatto affinché la lezione non venga annullata.",
      button: "Cos'altro?",
    },
    15: {
      title: "La lezione si svolgerà sulla nostra piattaforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Riceverai un link e un codice univoco via WhatsApp ed email. Basta cliccare sul link, ti porterà direttamente alla lezione. Senza app aggiuntive e senza download.",
      button: "Ho capito ✅",
    },
  },
};
